import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {ReportMileageSummaryLazy} from '@containers/reports/readyReports/reportMileageSummary/ReportMileageSummary.lazy';


const ReportMileageSummaryPage = () => {
    return (
        <PageLayout>
            <Suspense fallback={<SpinnerCustom/>}>
                <ReportMileageSummaryLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ReportMileageSummaryPage;